import {PagesInterface, ToggleModalsPayload} from './legacyModalsTypes';
import {Modals} from './modalsApi';

export const legacyModalsApi = {
    encodeId: (payload: ToggleModalsPayload): string => `${payload.page}::${payload.modal}`,
    decodeId: (fakeId: string) => {
        if (fakeId.indexOf('::') === -1) {
            return undefined;
        }
        const [page, modal] = fakeId.split('::');
        if (!page || !modal) {
            return undefined;
        }
        return {page, modal};
    },
    toggle<P extends keyof PagesInterface, M extends Extract<keyof PagesInterface[P], string>>(
        page: P,
        modal: M | (string & {})
    ) {
        return Modals.toggle(Modals.create(legacyModalsApi.encodeId({page: page, modal: modal})));
    },
    select<P extends keyof PagesInterface, M extends Extract<keyof PagesInterface[P], string>>(page: P, modal: M) {
        const selector = Modals.select(Modals.create(legacyModalsApi.encodeId({page: page, modal: modal})));
        return (state: AppModel) => {
            const [isOpen] = selector(state);
            return isOpen;
        };
    },
};
